<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <section class="qi-content">
        <header>
          <h1>Cadastro de Mailing</h1>
        </header>

        <vs-row>
          <NewSale />
        </vs-row>

        <vs-row class="input_container" vs-justify="center">
          <vs-row vs-justify="center">
            <vs-col>
              <h3 class="tituloForm">Escolha o Tipo de Venda</h3>
              <selected-mailing-box
                :chooseType="chooseType"
                v-on:change-choose-type="getForm"
                v-on:api-error="setError"
              >
              </selected-mailing-box>
            </vs-col>
          </vs-row>

          <vs-row
            v-if="['211', '242'].includes(chooseType) && formFields.length > 0"
            style="display: flex"
          >
            <vs-col vs-w="9">
              <h3 class="tituloForm">Validação de Cliente</h3>
              <vs-input
                v-if="chooseType == '242'"
                v-model="cnpjClient"
                label="CNPJ: *"
                v-mask="'##.###.###/####-##'"
                type="text"
              />
              <vs-input
                v-else
                v-model="telephoneClient"
                label="Telefone: *"
                v-mask="'(##) #########'"
                type="text"
              />
            </vs-col>
            <vs-col vs-w="3">
              <vs-button
                v-if="chooseType == '242'"
                style="width: 100%; margin-top: 51.5px"
                icon="search"
                :disabled="!cnpjClient || cnpjClient.length < 18"
                @click="validateCnpj"
              >
                Validar Prospect
              </vs-button>
              <vs-button
                v-else
                style="width: 100%; margin-top: 51.5px"
                icon="search"
                :disabled="!telephoneClient"
                @click="prospect(telephoneClient, 0)"
              >
                Validar Prospect
              </vs-button>
            </vs-col>

            <div
              v-show="errorProspect"
              style="width: 100% !important"
              vs-justify="center"
            >
              <vs-col>
                <vs-alert
                  color="danger"
                  closable
                  :active.sync="errorProspect"
                  close-icon="close"
                >
                  {{ errorProspect }}
                </vs-alert>
              </vs-col>
            </div>

            <div
              v-show="successProspect"
              style="width: 100% !important"
              vs-justify="center"
            >
              <vs-col>
                <vs-alert
                  color="success"
                  closable
                  :active.sync="successProspect"
                  close-icon="close"
                >
                  {{ successProspect }}
                </vs-alert>
              </vs-col>
            </div>
          </vs-row>

          <vs-col v-if="formFields.length > 0">
            <h3 class="tituloForm">Preencha o Formulário</h3>
            <vs-input
              v-model="campaignCode"
              label="Código da Campanha *"
              type="text"
              placeholder="Digite o código (ou 0 para sem campanha)"
              :danger="errors.includes('campaignCode')"
              danger-text="O código da campanha é obrigatório"
              style="margin-bottom: 15px;"
            />
            <dynamic-input
              v-for="(field, index) in formFields"
              :key="index"
              :type="field.type"
              :name="field.name"
              :label="getFieldTitle(field)"
              :items="field.items"
              :required="field.required"
              :danger="errors.includes(field.name)"
              :classes="getClass(field)"
              :value="field.value"
              v-on:input="handleChange($event, field)"
            />
            <vs-row vs-justify="center" vs-w="12">
              <vs-button
                icon="cloud_upload"
                color="#139B0E"
                class="btn-mailing"
                @click="registerMailing"
              >
                Cadastrar
              </vs-button>
            </vs-row>
          </vs-col>
          <vs-row v-show="error" vs-justify="center">
            <vs-col>
              <vs-alert
                color="danger"
                closable
                :active.sync="error"
                close-icon="close"
              >
                {{ error }}
              </vs-alert>
            </vs-col>
          </vs-row>
          <vs-row v-if="success" style="margin-top: 10px">
            <vs-alert
              color="success"
              closable
              :active.sync="success"
              close-icon="close"
            >
              <vs-col>
                Mailing Cadastrado com Sucesso! <br />
                <b>Código de Atendimento: {{ success.CODATENDIMENTO }}</b><br />
                <template v-if="campaignUtmData && campaignUtmData.UTM_CAMPAIGN">
                  Campanha: {{ campaignUtmData.UTM_CAMPAIGN }} <br />
                </template>

                <template v-if="campaignUtmData && campaignUtmData.UTM_SOURCE">
                  Source: {{ campaignUtmData.UTM_SOURCE }} <br />
                </template>

                <template v-if="campaignUtmData && campaignUtmData.UTM_MEDIUM">
                  Medium: {{ campaignUtmData.UTM_MEDIUM }} <br />
                </template>
              </vs-col>
              <vs-col>
                <vs-button
                  style="width: 100%"
                  icon="send"
                  color="#139B0E"
                  @click="startSimulation()"
                >
                  Ir para Matrícula
                </vs-button>
              </vs-col>
            </vs-alert>
          </vs-row>
        </vs-row>
      </section>
    </div>
  </div>
</template>

<script>
import MailingService from "../services/mailing";
import SelectedMailingBox from "../components/SelectedMailingBox.vue";
import DynamicInput from "../components/DynamicInput.vue";
import { updateStepsInformation } from "../helpers/storage";
import { validatePhone } from "../helpers/validation";

export default {
  name: "Mailing",
  components: {
    SelectedMailingBox,
    DynamicInput,
  },
  data: () => ({
    chooseType: "211",
    apiFormFields: [],
    formFields: [],
    errors: [],
    errorProspect: false,
    successProspect: false,
    telephoneClient: null,
    cnpjClient: "",
    cnpjCustomer: null,
    error: false,
    success: false,
    lastTypeCreated: 0,
    campaignCode: "",
    campaignUtmData: null,
    errorCampaign: false,
    successCampaign: false,
  }),
  mounted() {
    this.getForm(this.chooseType);
  },
  watch: {
    cnpjClient() {
      // CNPJ alterado depois de validado: exige nova validação
      this.cnpjCustomer = null;
    },
    apiFormFields(apiFormFields) {
      const formFields = apiFormFields
        .filter((field) => field.visible)
        .map((field) => {
          if (this.chooseType === '213' && field.name === 'CODCAMPANHA') {
            field.required = true;
          }
          const oldField = this.formFields.find(
            (oldField) => oldField.name === field.name
          );
          if (oldField && oldField.value) {
            if (
              (field.type === "select" &&
                field.items.find((item) => oldField.value === item.value)) ||
              field.type !== "select"
            ) {
              return {
                ...field,
                value: oldField.value,
              };
            }
          }
          if (field.type === "select") {
            if (field.items.length === 1 && field.required) {
              return {
                ...field,
                value: field.items[0].value,
              };
            }
            if (field.name === "CODETD" || field.name === "ESTADO") {
              const defaultValue = field.items.find((state) =>
                state.value.includes(`"${field.defaultValue || "RS"}"`)
              );
              return {
                ...field,
                value: defaultValue.value,
              };
            }
          }
          return {
            ...field,
            value: field.defaultValue || "",
          };
        });
      this.formFields = formFields;
    },
  },
  methods: {
    async searchCampaign() {
      this.errorCampaign = false;
      this.successCampaign = false;
      this.campaignUtmData = null;

      this.$vs.loading();
      try {
        const treatedCode = this.campaignCode.replace(/[^a-zA-Z0-9]/g, '');
        const response = await new MailingService().getCampaignUtms(treatedCode);
        this.campaignUtmData = response.data;

        this.successCampaign = "Campanha vinculada com sucesso! Parâmetros carregados.";
      } catch (error) {
        this.errorCampaign = error?.response?.data?.error || "Erro ao buscar a campanha.";
      } finally {
        this.$vs.loading.close();
      }
    },
    prospect(phone) {
      this.successProspect = false;
      this.errorProspect = false;

      const telephone = phone.replace(/[ ()-]/g, "");
      const payload = {
        telephone: telephone,
        externalLink: 0,
      };

      this.$vs.loading();
      new MailingService()
        .validateProspect(payload)
        .then((res) => {
          console.log(res);

          this.successProspect =
            "Não foi localizado atendimento aberto com " +
            phone +
            ". É possível a criação do atendimento.";
        })
        .catch((error) => {
          this.errorProspect = error.response.data.error;
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    validateCnpj() {
      this.successProspect = false;
      this.errorProspect = false;
      this.cnpjCustomer = null;

      this.$vs.loading();
      new MailingService()
        .validateProspect({ cnpj: this.cnpjClient, externalLink: 0 })
        .then((res) => {
          this.cnpjCustomer = res.data;
          this.successProspect =
            "Empresa localizada: " +
            (res.data.NOMEFANTASIA || res.data.NOME) +
            " (cliente " +
            res.data.CODCFO +
            "). É possível a criação do atendimento.";
        })
        .catch((error) => {
          this.errorProspect =
            error?.response?.data?.error || "Erro ao validar o CNPJ.";
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    goTo(route) {
      this.$router.push(route);
    },
    startSimulation() {
      updateStepsInformation({
        codAtendimento: this.success.CODATENDIMENTO,
        codColigada: this.success.CODCOLIGADA,
        codLocal: this.success.CODLOCAL,
      });
      this.$router.push("/courses");
    },
    handleChange(newValue, field) {
      field.value = newValue;
      if (["CODEDT", "ESTADO"].includes(field.name)) {
        this.$vs.loading();
        const parsedNewValue = JSON.parse(newValue);
        new MailingService()
          .getCities(parsedNewValue.CODIGO)
          .then((res) => {
            const citiesField = this.formFields.find(
              (field) => field.name === "CODMUNICIPIO"
            );
            citiesField.items = res.data;
          })
          .catch((error) => {
            console.error("Error trying to fetch cities", error);
            this.error =
              "Erro ao buscar cidades do estado " + parsedNewValue.NOME;
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      }
    },
    setError(error) {
      this.error = error;
    },
    getClass(field) {
      return {
        "select-faded": field.value === "",
      };
    },
    getError({ error = false }) {
      return error;
    },
    getFieldTitle({ title, required }) {
      return `${title}${required ? " *" : ""}`;
    },
    getForm(newChooseType) {
      this.chooseType = newChooseType;
      this.errors = [];

      if (newChooseType) {
        this.$vs.loading();
        this.success = false;

        new MailingService()
          .getForm(newChooseType)
          .then((res) => {
            this.apiFormFields = res.data || [];
          })
          .catch((error) => {
            console.error("Error trying to get form", error);
            this.apiFormFields = [];
            this.error =
              "Falha ao tentar carregar o formulário. " +
              error.response.data.error;
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      } else {
        this.apiFormFields = [];
      }
    },
    async registerMailing() {
      this.success = false;
      this.error = false;
      const errors = [];

      if (!this.campaignCode || this.campaignCode.trim() === '') {
        errors.push('campaignCode');
      }
      this.formFields.forEach((field) => {
        if (field.required && field.value !== 0 && !field.value) {
          errors.push(field.name);
        }
      });
      var phone = this.formFields.find((field) => field.name == "TELEFONE");

      if (phone && !validatePhone(phone.value)) {
        errors.push(phone.name);
      }

      this.errors = errors;

      if (errors.length) {
        return;
      }

      if (this.chooseType == "242" && !this.cnpjCustomer) {
        this.error = "Valide o CNPJ da empresa antes de cadastrar.";
        return;
      }

      this.$vs.loading();

      this.campaignUtmData = null;

      const payload = this.formFields.reduce((payload, field) => {
        if (field.value === 0 || field.value) {
          return {
            ...payload,
            [field.name]: field.value,
          };
        }
        return payload;
      }, {});

      const externalLink = this.apiFormFields.find(
        (field) => field.name === "LINKEXTERNO"
      );
      if (externalLink) {
        payload["LINKEXTERNO"] = externalLink.defaultValue || 0;
      }

      if (this.campaignCode !== '0') {
        try {
          const treatedCode = this.campaignCode.replace(/[^a-zA-Z0-9]/g, '');
          const response = await new MailingService().getCampaignUtms(treatedCode);

          const campaignUtmData = response.data;

          this.campaignUtmData = campaignUtmData;

          payload["PARAMETRO_165"] = campaignUtmData.UTM_SOURCE || '';
          payload["PARAMETRO_166"] = campaignUtmData.UTM_CAMPAIGN || '';
          payload["PARAMETRO_167"] = campaignUtmData.UTM_MEDIUM || '';
          payload["PARAMETRO_173"] = campaignUtmData.UTM_TERM || '';
          payload["PARAMETRO_174"] = campaignUtmData.UTM_CONTENT || '';
          payload["PARAMETRO_236"] = campaignUtmData.GCLID || '';
          payload["PARAMETRO_238"] = campaignUtmData.ID_REF || '';

          if (campaignUtmData.CONTEXTO) {
              payload["CURSO"] = campaignUtmData.CONTEXTO;
          }
        } catch (error) {
          this.error = error?.response?.data?.error || "Código de campanha inválido ou não encontrado.";
          this.$vs.loading.close();
          return;
        }
      }

      if (this.chooseType == "242") {
        payload["CNPJ"] = this.cnpjClient;
      } else if (payload["TELEFONE"]) {
        payload["TELEFONE"] = payload["TELEFONE"].replace(/[ ()-]/g, "");
        try {
          const res = await new MailingService().validateProspect({
            telephone: payload["TELEFONE"],
            externalLink: 0,
          });
          if (res.status >= 400) {
            throw new Error(res);
          }
        } catch (error) {
          if (error?.response?.data?.error) {
            this.error = error.response.data.error;
          }
          this.$vs.loading.close();
          return;
        }
      } else {
        this.$vs.loading.close();
        return;
      }

      this.lastTypeCreated = 0;
      new MailingService()
        .registerMailing({
          ...payload,
          CODTIPOATENDIMENTO: this.chooseType,
        })
        .then((res) => {
          this.success = res.data;
          this.lastTypeCreated = this.chooseType;
          this.campaignCode = "";
          this.cnpjClient = "";

          this.formFields.forEach((element) => {
            if (
              element.type == "input" ||
              element.type == "textarea" ||
              element.type == "text-telephone" ||
              element.type == "text-email"
            )
              element.value = "";
          });
        })
        .catch((error) => {
          console.error("Error: " + error);
          this.error =
            "Falha ao tentar cadastrar mailing. " +
            (error?.response?.data?.error || "");
        })
        .finally(() => {
          setTimeout(() => {
            this.$vs.loading.close();
          }, 200);
        });
    },
  },
};
</script>

<style>
.btn-mailing {
  width: 50%;
  margin-top: 15px;
}
.tituloForm {
  padding: 10px 0px;
  font-weight: normal;
  color: #0a0a0a;
}
.vs-input {
  width: 100% !important;
}

a.inline {
  text-decoration-style: solid;
}

.input_container {
  padding-bottom: 32px;
}

.vs-textarea,
.vs-textarea:focus {
  resize: none !important;
}
.input-icon-validate,
.vs-input--icon-validate {
  display: none;
}
.select-faded .vs-select--input,
.con-select .vs-select--label,
.vs-con-input-label.vs-input label.vs-input--label {
  color: rgba(0, 0, 0, 0.6);
}
.w-100 {
  width: 100%;
}

@media screen and (max-width: 600px) {
  .btn-mailing {
    width: 93.5%;
  }
}
</style>
